export const TEMPLATE_TABLE_CONSTANTS = {
  LABELS: {
    TEMPLATE_NAME: 'Template Name',
    TYPE: 'Type',
    STATUS: 'Status',
    DEFAULT: 'Default',
    USAGE_COUNT: 'Usage Count',
    LAST_USED: 'Last Used',
    CREATED: 'Created',
    ACTIONS: 'Actions',
    USAGE: 'Usage',
  },
  BUTTONS: {
    PREVIEW_HTML: 'Preview HTML',
    VIEW_EDIT: 'View/Edit',
    SEND_TEST: 'Send Test',
    DUPLICATE: 'Duplicate',
    SET_AS_DEFAULT: 'Set as Default',
    DELETE: 'Delete',
    CLOSE: 'Close',
    EDIT_TEMPLATE: 'Edit Template',
  },
  MODAL_TITLES: {
    PREVIEW: 'Preview',
    HTML_SOURCE: 'HTML Source',
  },
  MESSAGES: {
    NO_TEMPLATES: 'No email templates found',
    NO_TEMPLATES_DESCRIPTION:
      'Create your first template to get started with email automation',
    NO_CONTENT: 'No content available',
    NO_HTML_CONTENT: 'No HTML content available',
    SUBJECT_PREFIX: 'Subject:',
    BY_PREFIX: 'by',
    UPDATED_PREFIX: 'Updated:',
    NEVER: 'Never',
  },
  ICON_SIZES: {
    EMPTY_STATE: 16,
  },
  RESPONSIVE: {
    DESKTOP_MIN_WIDTH: '1000px',
    TABLET_MIN_WIDTH: '800px',
  },
} as const;
